import React from "react";
import { requestResetPassword } from "shared/api/client/orvalHelpers";
import "../../../styles/legacy/Login.css";

interface ResetPasswordProps {
  email: string;
  setEmail: (email: string) => void;
  onClose: () => void;
  onSuccess: (msg: string) => void;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({
  email,
  setEmail,
  onClose,
  onSuccess,
}) => {
  const handleResetPassword = async () => {
    try {
      await requestResetPassword(email);
      onSuccess("Password reset email sent.");
      onClose();
    } catch (err) {
      console.error("Reset password error:", err);
      onClose();
    }
  };

  return (
    <div className="modal-reset-password" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2 className="modal-title">Reset password</h2>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="close-button"
          onClick={onClose}
        >
          <path
            d="M8 6.22222L1.77778 0L0 1.77778L6.22222 8L0 14.2222L1.77778 16L8 9.77778L14.2222 16L16 14.2222L9.77778 8L16 1.77778L14.2222 0L8 6.22222Z"
            fill="#A3A3A3"
          />
        </svg>
      </div>
      <div className="modal-divider" />
      <div className="modal-content">
        <div className="reset-email-container">
          <span className="reset-email-label">Email</span>
          <input
            type="email"
            placeholder="Enter your email address"
            className="reset-input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className="reset-supporting-text">
            We'll send you a link to reset your password
          </p>
        </div>
      </div>
      <div className="modal-divider" />
      <div className="modal-actions">
        <button className="cancel-button" onClick={onClose}>
          Cancel
        </button>
        <button
          className="reset-button"
          onClick={handleResetPassword}
          disabled={!email}
        >
          Reset password
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
